import React from 'react';
import QRCode from 'react-qr-code';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import css from './QRCodeComponent.module.css';

const QRCodeComponent = ({ url, className }) => {
  return (
    <div className={classNames(className, css.qrWrapper)}>
      <p className={css.label}>
        <FormattedMessage id="General.handover" />
      </p>
      <QRCode value={url} size={128} />
    </div>
  );
};

export default QRCodeComponent;
